jQuery(document).ready(function($) {

    /*setInterval(function(){
        $('.gallery__list-thumbnails .gallery__thumbnail:first').appendTo('.gallery__list-thumbnails');
    }, 4000);*/
    /*$('.gallery__list-thumbnails').flickity({
      autoPlay: true,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      contain: true
  });*/
    var $emailShareForm = $('.share-by-email__form');

    if( $emailShareForm.length ){
        var $messageField = $('.share-by-email__form').find('textarea');

        $messageField.text(window.location.href);
    }

    $('.menu-sharebar__item.share--email').click(function(e) {
        e.preventDefault();
        var $form = $('.share-by-email__form');

        $form.toggleClass('visible');
    });

    $('.share-by-email__form-close').click(function(e) {
        e.preventDefault();
        var $form = $('.share-by-email__form');

        $form.toggleClass('visible');
    });

})
